/*
 * Determines if a string is an integer number
 */
String.prototype.isInteger = function (allowNegatives) {
    if (!this) return false;
    var n = Number(this);

    return Number.isInteger(n) && (allowNegatives === true || n >= 0);
};